import React from 'react'
import { graphql } from 'gatsby'
// import { Link, graphql } from 'gatsby'

import Layout from '../layouts/layout'
import Chat from '../components/chat'

export default function Template ({ data }) {
  const article = data.markdownRemark

  return (
    <Layout>
      <Chat />
      <div>
        <h1>{article.frontmatter.title}</h1>
        <h4>
          Posted by {article.frontmatter.author} on {article.frontmatter.date}
        </h4>
        <div dangerouslySetInnerHTML={{ __html: article.html }} />
      </div>
    </Layout>
  )
}

export const articleQuery = graphql`
  query ArticleById($id: String!) {
    markdownRemark(id: {eq: $id}) {
      html
      frontmatter {
        path
        title
        path
        date
      }
    }
  }
`
